import { render } from "./DualButton.vue?vue&type=template&id=193cfb2e&scoped=true"
import script from "./DualButton.vue?vue&type=script&lang=js"
export * from "./DualButton.vue?vue&type=script&lang=js"

import "./DualButton.vue?vue&type=style&index=0&id=193cfb2e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-193cfb2e"

export default script